import './chroma-fix'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd'
import * as serviceWorker from './serviceWorker'

import './index.css'
import App from './App'
import { store, persistor } from './store.js'
import { PersistGate } from 'redux-persist/integration/react'

import axios from 'axios'
serviceWorker.register()

// Set axios to globally send and receive cookies (for credentials/auth)
axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'https://wiseacademybackend.vercel.app'

// Custom theme configuration based on ReferenceFrontend colors
const theme = {
  primaryColor: 'hsl(210, 55%, 22%)', // Dark blue from ReferenceFrontend
  errorColor: '#ff4d4f',
  warningColor: '#faad14',
  successColor: '#52c41a',
  infoColor: 'hsl(210, 55%, 22%)',
}

ReactDOM.render(
  <ConfigProvider theme={theme}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </ConfigProvider>,
  document.getElementById('root')
)
